import {jQuery} from "./boot";
import {tableRowRemoteSwitch} from "./lib/RemoteSwitch";
import {AppConfig} from "./AppConfig";
import {apiPost} from "./lib/SecuredAjax";
import {showToastError} from "./lib/boostrapToast";

export class TransportListPage {
	private readonly canSwitch: boolean

	constructor({canSwitch}: { canSwitch?: boolean }) {
		this.canSwitch = canSwitch != undefined && canSwitch

		if (this.canSwitch) {
			tableRowRemoteSwitch(jQuery('div[data-position-switch]'), id => `${AppConfig.CP}/transports/${id}/switchEnabled`);

			jQuery('div[data-position-switch] input').on('change', function () {
				const input = jQuery(this);
				const id = input.closest('tr').data('id');
				const hasPosition = input.closest('tr').attr('has-position') === 'true';

				const hideButton = jQuery(`button#tState${id}_hide`);
				if (!input.is(':checked') || !hasPosition) {
					hideButton.removeAttr('hidden');
				} else {
					hideButton.attr('hidden', '');
				}

				if (!input.is(':checked') && hasPosition) {
					hideButton.removeAttr('disabled')
				} else {
					hideButton.attr('disabled', '')
				}
			});

			jQuery('button[id$="_hide"]').on('click', function () {
				const input = jQuery(this);
				const id = input.closest('tr').data('id');

				apiPost(`${AppConfig.CP}/transports/${id}/hide`, {})
					.then(res => {
						input.addClass('active');
						input.attr('disabled', 'disabled');
						input.closest('tr').attr('has-position', 'false');
					})
					.catch(err => {
						showToastError(err);
					});
			});

		}
	}
}